import { Component, ElementRef, Inject, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';
import { Contact, ContactType } from '../tile/tile';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalPhoneComponent } from './modal-phone/modal-phone.component';

import { TrackingContactUsService } from '../tracking/tracking-contact-us.service';
import { WindowScrollerService } from '../services/window-scroller.service';
import { DomService } from '../library/dom.service';
import { EchatService } from './echat/echat.service';
import { DjingoService } from '../library/djingo.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class ContactComponent implements OnChanges {
  @Input() contacts: Contact[];
  @Input() tilesTitle: string[];
  @Input() segment2: string;

  solutions: Contact[];

  contact: Contact[];
  contactCtc: Contact;
  contactEmail: Contact;
  contactPhone: Contact;
  contactEchat: Contact;
  contactDjingo: Contact;

  queryParameters: string;
  queryValue: string;
  queryParam: string;
  methodName: string;

  constructor(
    protected modalService: NgbModal,
    private echatService: EchatService,
    // private djingoService: DjingoService,
    private trackingService: TrackingContactUsService,
    public elementRef: ElementRef,
    @Inject('WindowScrollerService') private windowScrollerService: WindowScrollerService,
    @Inject('EnvironmentProvider') private environmentProvider,
    private domService: DomService,
    private djingoService: DjingoService,
    private renderer: Renderer2
  ) {}

  scrollIntoView = () => {
    // Warning timeout must > to timeout in titles scroll
    setTimeout(() => {
      this.windowScrollerService.scrollIntoViewOffset(this.elementRef.nativeElement, -10);
    }, 200);
  };
  isSollicitationFormUrl(url: string): boolean {
    return (
      url === 'https://qualif.espace-client.orange-business.com/contact-form' ||
      url === 'https://espace-client.orange-business.com/contact-form'
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.contacts) {
      this.solutions = this.contacts.filter(
        (contact) =>
          contact.type === ContactType.applicationFederee.valueOf() ||
          contact.type === ContactType.espaceUtilisateur.valueOf() ||
          contact.type === ContactType.mobile.valueOf() ||
          contact.type === ContactType.communaute.valueOf()
      );

      this.contactEchat = this.contacts.filter((contact) => contact.type === ContactType.echat.valueOf()).pop();
      this.contactPhone = this.contacts.filter((contact) => contact.type === ContactType.conseiller.valueOf()).pop();
      this.contactEmail = this.contacts.filter((contact) => contact.type === ContactType.email.valueOf()).pop();
      if (this.contactEmail) {
        this.methodName = 'post';
        if (this.isSollicitationFormUrl(this.contactEmail.url)) {
          this.methodName = 'get';
          this.queryParameters = 'context=ece';
          this.queryValue = this.queryParameters.split('=')[1];
          this.queryParam = this.queryParameters.split('=')[0];
        }
      }
      this.contactCtc = this.contacts.filter((contact) => contact.type === ContactType.callback.valueOf()).pop();
      this.contactDjingo = this.contacts.filter((contact) => contact.type === ContactType.djingo.valueOf()).pop();

      if (this.contacts.length > 0) {
        this.scrollIntoView();
      }

      if (this.contactDjingo !== undefined) {
        this.djingoService.loadDjingoScript(this.renderer, this.environmentProvider.djingoScriptUrl);
        let intentionTruncated = '';
        if (this.contactDjingo && this.contactDjingo.intention) {
          intentionTruncated = this.contactDjingo.intention.substring(0, 60);
        }
        this.djingoService.djingoChatConfig(this.environmentProvider.djingoCallerId, intentionTruncated, false, false);
      }
    }
  }

  openEchat(reasonNewton?: string) {
    this.echatService.openEchat(this.contactEchat.url, reasonNewton);
    this.trackingService.trackContact('e-chat');
  }

  openPhone() {
    const modalRef = this.modalService.open(ModalPhoneComponent, {
      windowClass: 'modal-custom-class',
      // backdrop: 'static',
      centered: true,
      size: 'lg',
      // beforeDismiss: () => this.deleteEceMask(),
    });
    modalRef.componentInstance.phones = this.contactPhone.listPhone;
    this.trackingService.trackContact('conseiller');
  }

  openCtc() {
    this.domService.openWindow(
      this.contactCtc.url,
      'nouscontacter',
      'width=950, height=700, scrollbars=yes, resizable=yes, location=no, status=no, toolbar=no, menubar=yes'
    );
    this.trackingService.trackContact('callback');
  }

  openEmail() {
    this.trackingService.trackContact('email');
    if (this.isSollicitationFormUrl(this.contactEmail.url)) {
      this.domService.location(this.contactEmail.url + '?context=ece');
    } else {
      this.domService.openWindow(
        '',
        'nouscontacter',
        'width=950, height=700, scrollbars=yes, resizable=yes, location=no, status=no, toolbar=no, menubar=yes'
      );

      const doc = this.domService.getDocument();
      const form = doc.getElementById('formulaireEmail') as HTMLFormElement;
      if (form && form.submit) {
        form.submit();
      }
    }
  }

  openDjingo() {
    this.djingoService.open();
    this.trackingService.trackContact('djingo');
  }

  getSolutionTitle(type: ContactType) {
    switch (type) {
      case ContactType.applicationFederee: {
        return 'Depuis votre espace en ligne';
      }
      case ContactType.espaceUtilisateur: {
        return 'Depuis votre espace client utilisateur';
      }
      case ContactType.mobile: {
        return 'Depuis votre mobile';
      }
      case ContactType.communaute: {
        return "Depuis votre communauté d'experts Orange Business Services";
      }
      default: {
        return '';
      }
    }
  }

  sendTrackingSolution(solutionType: string) {
    switch (solutionType) {
      case ContactType.applicationFederee: {
        this.trackingService.trackContact('espace client entreprise');
        return;
      }
      case ContactType.espaceUtilisateur: {
        this.trackingService.trackContact('espace client utilisateur');
        return;
      }
      case ContactType.mobile: {
        this.trackingService.trackContact('depuis votre mobile');
        return;
      }
      case ContactType.communaute: {
        this.trackingService.trackContact('communauté experts OBS');
        return;
      }
    }
  }

  getMailReasonContact() {
    let reasonContact = '';
    if (this.tilesTitle) {
      Array.from(this.tilesTitle).map((tile) => {
        if (reasonContact === '') {
          reasonContact += tile;
        } else {
          reasonContact += ` > ${tile}`;
        }
      });
    }
    return reasonContact;
  }

  getEchatReasonContact() {
    let reasonContact = '';
    let index = 0;
    if (this.tilesTitle) {
      Array.from(this.tilesTitle).map((tile) => {
        index++;
        if (reasonContact === '') {
          reasonContact += `motifNv${index}:${tile}`;
        } else {
          reasonContact += `|motifNv${index}:${tile}`;
        }
      });
      index++;
      for (; index <= 4; index++) {
        reasonContact += `|motifNv${index}:`;
      }
    }
    return reasonContact;
  }

  clicOnSolution(solutionType: string, url: string) {
    if (url && url !== '') {
      this.sendTrackingSolution(solutionType);
      this.domService.openWindow(url, '_blank', '');
    }
  }
}
